var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1507"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19 13.25H17.9375V9.75C17.9375 8.64531 17.0422 7.75 15.9375 7.75H12.0625C10.9578 7.75 10.0625 8.64531 10.0625 9.75V13.25H9C8.72344 13.25 8.5 13.4734 8.5 13.75V19.75C8.5 20.0266 8.72344 20.25 9 20.25H19C19.2766 20.25 19.5 20.0266 19.5 19.75V13.75C19.5 13.4734 19.2766 13.25 19 13.25ZM14.4375 16.9531V17.7812C14.4375 17.85 14.3812 17.9062 14.3125 17.9062H13.6875C13.6188 17.9062 13.5625 17.85 13.5625 17.7812V16.9531C13.4335 16.8605 13.3373 16.7294 13.2875 16.5786C13.2378 16.4278 13.2373 16.2651 13.2859 16.114C13.3345 15.9628 13.4299 15.831 13.5582 15.7375C13.6865 15.644 13.8412 15.5936 14 15.5936C14.1588 15.5936 14.3135 15.644 14.4418 15.7375C14.5701 15.831 14.6655 15.9628 14.7141 16.114C14.7627 16.2651 14.7622 16.4278 14.7125 16.5786C14.6627 16.7294 14.5665 16.8605 14.4375 16.9531ZM16.8125 13.25H11.1875V9.75C11.1875 9.26719 11.5797 8.875 12.0625 8.875H15.9375C16.4203 8.875 16.8125 9.26719 16.8125 9.75V13.25Z",
    fill: "#1660CF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 9",
    cx: 14,
    cy: 14,
    r: 13.5,
    stroke: "#1660CF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundLock);
export default __webpack_public_path__ + "static/media/round-lock.4c2a757e3a18ac7a749a90399323b6d0.svg";
export { ForwardRef as ReactComponent };